import React, { ReactElement } from 'react';
import Box from '../../components/Box/Box';
import Icon from '../../components/Icon/Icon';
import { SuccessBadge } from '../../components/Badge';
import getComponentClassNames from '../../utils/className/getComponentClassNames';
import { TIcon } from '../../types/TStyleVariables';

const classNames = getComponentClassNames(['CategoryMenuBarItem'], ['link', 'selected']);

type TCategoryMenuBarItemProps = {
  label: string;
  href: string;
  icon?: number | string;
  children?: ReactElement;
  className?: string;
  attr?: {};
  badgeLabel?: string;
  isSelected?: boolean;
};

const CategoryMenuBarItem = ({
  href,
  label,
  icon,
  attr,
  badgeLabel,
  isSelected,
  ...rest
}: TCategoryMenuBarItemProps) => (
  <Box {...rest} as="div" parent="CategoryMenuBar" name="Item">
    <a
      className={`${classNames.link}${isSelected ? ` ${classNames.selected}` : ''}`}
      href={href}
      aria-current={isSelected ? 'page' : undefined}
      {...attr}
    >
      {icon && <Icon name={icon.toString() as TIcon} />}
      {label}
      {Boolean(badgeLabel) && <SuccessBadge utilities={['marginLeftXxxs']}>{badgeLabel}</SuccessBadge>}
    </a>
  </Box>
);

export default CategoryMenuBarItem;
